import React, { Component } from 'react';
import Select from 'react-select';

import { getBtnClass } from '@triage-help/helpers';

class ChannelSelection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedChannels: [],
    };
    this.channelCheckbox = React.createRef();
    this.channelOptions = [];

    Object.keys(props.step.channels).forEach(key => {
      this.channelOptions.push({
        value: key,
        label: props.step.channels[key],
      });
    });
  }

  checkCondition(link) {
    const { selectedChannels } = this.state;
    if (link.condition) {
      if (eval(link.condition)) {
        this.props.updateChannels(this.state.selectedChannels);
        this.props.goToStep(link.target);
      }
    } else {
      this.props.updateChannels(this.state.selectedChannels);
      this.props.goToStep(link.target);
    }
  }

  handleSelect(selection) {
    if (this.channelCheckbox.checked) {
      this.channelCheckbox.checked = false;
    }
    this.setState({
      selectedChannels: Array.isArray(selection) ? selection : [],
    });
  }

  handleCheckbox(e) {
    this.select.state.value = [];
    if (e.target.checked) {
      this.setState({
        selectedChannels: this.channelOptions,
      });
    } else {
      this.setState({
        selectedChannels: [],
      });
    }
  }

  render() {
    const { step, location, goToStep, goToPrev } = this.props;
    const prevLink = step.link.find(l => l.type == 'prev');

    const linksEndClass =
      step.link.length == 1 ? 'fv-triage-card__links--end' : '';

    return (
      <div className="fv-triage-card">
        <div className="row">
          <div className="col-sm-12 col-md-7 fv-triage-card__content">
            <div dangerouslySetInnerHTML={{ __html: step.content }} />
          </div>
          <div className="col-sm-12 col-md-5 fv-triage-card__side fv-triage-card__channels">
            <Select
              ref={ref => {
                this.select = ref;
              }}
              className="react-select-container"
              classNamePrefix="react-select"
              options={this.channelOptions}
              isMulti={true}
              onChange={this.handleSelect.bind(this)}
            />
            <p className="small--xs">Select multiple</p>
            <div className="fv-triage-card__cta">
              <input
                type="checkbox"
                name="all-chans"
                id="all-chans"
                ref={this.channelCheckbox}
                onChange={this.handleCheckbox.bind(this)}
              />
              <label htmlFor="all-chans">It's all of them</label>
              <label
                htmlFor="all-chans"
                className="fv-triage-card__cta__label"
              />
            </div>
          </div>

          <div className={`col-md-12 fv-triage-card__links ${linksEndClass}`}>
            {prevLink && (
              <button
                className={getBtnClass(prevLink.type)}
                onClick={() => goToPrev()}
              >
                {prevLink.text}
              </button>
            )}
            <div className="fv-triage-card__links__next">
              {step.link
                .filter(l => l.type != 'prev')
                .map((link, i) => {
                  const { selectedChannels } = this.state;

                  return (
                    <button
                      className={getBtnClass(
                        link.type,

                        link.condition ? eval(link.condition) : true,
                      )}
                      key={i}
                      onClick={() => this.checkCondition(link)}
                    >
                      {link.text}
                    </button>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChannelSelection;
